import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { ContactSchema } from "../generated/prisma/zod";

const c = initContract();

export const contactsContract = c.router({
  findOne: {
    method: "GET",
    path: "/contacts/:id",
    responses: {
      200: ContactSchema,
    },
    summary: "Get a contact",
  },
  create: {
    method: "POST",
    path: "/contacts",
    responses: {
      201: ContactSchema.merge(z.object({ clientId: z.string() })),
    },
    body: z.object({
      clientId: z.string(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
      phone: z.string().optional(),
    }),
    summary: "Create a contact",
  },
  update: {
    method: "PATCH",
    path: "/contacts/:id",
    responses: {
      200: ContactSchema.merge(z.object({ clientId: z.string() })),
    },
    body: z.object({
      firstName: z.string().optional(),
      lastName: z.string().optional(),
      email: z.string().optional(),
      phone: z.string().optional(),
    }),
    summary: "Update a contact",
  },
});
